import React, { Component } from 'react';
import * as Constants from '../Utilities/Constants';

export default class NumberPad extends Component {

  render(){
    //do props get questionnaire question, if it doesn't exist, do get test question and add the ammount of the questionnaire questions from the constants
    const totalQuestionPages = Object.keys(Constants.PT_QUESTION_NAMES).length;
    const totalTestPages = Object.keys(Constants.RECORDING_NAMES).length

    //3 is added for the 2 symbol matching tasks and the 1 demo
    let totalPages = totalQuestionPages + totalTestPages + 4;

    let qPages = this.props.questionnairePage ? this.props.questionnairePage : totalQuestionPages; 
    let tPages = this.props.testPage ? this.props.testPage : 0;

    let currentPage = qPages + tPages;

    return (
      <div className='pageNumber'>
          {currentPage + '/' + totalPages}
      </div>
    );
  }
}